/* Lenis. Medido contra el sticky lado a lado: no lo toca (el hero se clava en 0
   y suelta en -170 igual con y sin él; no aplica transform a html/body).

   🔴 Requiere que NADIE MÁS anime el scroll: con `html{scroll-behavior:smooth}`
   activo los dos motores pelean y la rueda deja de responder. El CSS de arriba
   lo anula, pero SOLO bajo `html.lenis` — sin JS el sitio conserva su scroll
   suave nativo. */
/* 🔴 EN EL TELÉFONO NO SE INSTANCIA. Segunda vez que paco reporta que «no se
   siente bien en el dedo», y la conclusión honesta es que en táctil Lenis ya no
   aporta nada:

   · Sus tres orejas táctiles se le quitan abajo, así que el arrastre ya era
     nativo. Lo que quedaba corriendo era un `requestAnimationFrame` sesenta
     veces por segundo, cada segundo, para no mover el scroll.
   · Su único trabajo restante —el viaje suave de los anclas del menú— lo hace
     el navegador solo: `sitio.css` trae `html{scroll-behavior:smooth}` desde el
     primer día y el hueco del encabezado vive en `scroll-margin-top`. Lenis los
     anula con SU PROPIA clase (`.lenis.lenis-smooth`), que sin instanciarlo
     nunca se pone. O sea que apagarlo devuelve el camino nativo entero, no lo
     rompe.

   `(pointer: fine)` es la pregunta correcta, no el ancho de pantalla: distingue
   un ratón de un dedo. Un portátil táctil tiene las dos cosas y conserva Lenis;
   un teléfono no lo carga nunca.

   Lo que se gana: la inercia, el rebote y la velocidad son EXACTAMENTE los del
   sistema, no una imitación. Eso no se puede empatar desde JavaScript. */
if (!matchMedia('(prefers-reduced-motion: reduce)').matches
    && matchMedia('(pointer: fine)').matches
    && window.Lenis) {
  // 1.05 se sentía flotando. .85 con esta rampa responde al primer golpe y
  // sigue frenando suave, que es lo que se quería.
  const lenis = new Lenis({
    duration: .85,
    easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
    wheelMultiplier: 1
  });
  (function tic(t){ lenis.raf(t); requestAnimationFrame(tic); })();
  window.__lenis = lenis;

  /* 🔴 EL DEDO NO PASA POR AQUÍ. MEDIDO: Lenis registra `touchstart` y
     `touchmove` en `window` con `passive:false` — en las cuatro páginas que
     probé, sin excepción. Un oyente de `touchmove` no pasivo saca al navegador
     de su camino rápido: ya no puede mover la página en el compositor, tiene
     que esperar a que el JS decida si va a cancelar el gesto. El resultado es
     un retraso entre el dedo y el papel, y una inercia que no es la del
     sistema. Eso es exactamente el «algo raro» que se siente y que no aparece
     en ninguna medición de cuadros (el JS de scroll cuesta 0.06 ms por tick:
     el problema nunca fue el trabajo, fue el permiso).

     Y lo peor: con `syncTouch` apagado —que es como corre— Lenis RECIBE esos
     eventos y acto seguido se declara «native» y no hace nada con ellos. Se
     paga el costo completo por cero beneficio.

     Se le quitan las tres orejas táctiles y se queda solo con la rueda, que es
     para lo que está. En celular el desplazamiento pasa a ser el de iOS: su
     inercia, su rebote, su velocidad. Si una versión futura de Lenis renombra
     estos handlers, el `try` deja el sitio como estaba hoy — no lo rompe. */
  try {
    const vs = lenis.virtualScroll;
    [['touchstart', vs.onTouchStart], ['touchmove', vs.onTouchMove],
     ['touchend', vs.onTouchEnd]].forEach(([evento, fn]) => {
      if (fn) vs.element.removeEventListener(evento, fn, { passive: false });
    });
  } catch (_) { /* se queda el comportamiento anterior, no se cae nada */ }

  /* Sin el dedo dentro, `touchMultiplier` ya no significa nada: se quitó de la
     configuración de arriba para que nadie lo vuelva a ajustar creyendo que
     mueve algo. */

  /* Al anular `scroll-behavior:smooth`, los anclas del menú saltarían de golpe.
     Se cablean por Lenis, y de paso llevan el hueco del encabezado pegajoso —
     lo mismo que hacía `scroll-margin-top`, que tampoco aplica ya. */
  const alto = () => (document.querySelector('.nav')?.offsetHeight || 0) + 12;
  const meta = el => Math.round(el.getBoundingClientRect().top + scrollY - alto());

  /* 🔴 Lenis calcula el objetivo UNA VEZ y no lo vuelve a mirar. Medido: al picar
     "Bloom Library" el destino estaba en 9672, la página CRECIÓ 57 px durante el
     viaje —imágenes diferidas que entran arriba— y aterrizaba 1200 px corto, o
     sea con la sección fuera de pantalla. Se le pasa un NÚMERO (no el elemento)
     y al terminar se vuelve a medir: si quedó lejos, un segundo salto corto lo
     cuadra. Es la diferencia entre "casi llega" y "llega". */
  function irA(destino){
    lenis.scrollTo(meta(destino), { duration: 1.1, onComplete(){
      const falta = meta(destino) - Math.round(scrollY);
      if (Math.abs(falta) > 6) lenis.scrollTo(meta(destino), { duration: .4 });
    }});
  }

  document.addEventListener('click', e => {
    /* 🔴 DOS ENLACES DE ALMOHADILLA QUE NO SON UN ANCLA, Y LOS DOS ROMPÍAN AQUÍ.

       (a) LA PÍLDORA DEL CARRITO. Dejó de ser cromo (`href="#"`, que esta función
           ya saltaba) y pasó a `href="#bolsa"` para que sin JS lleve a algún
           lado. Con eso empezó a caer en este oyente: `bolsa.js` abría el cajón
           y acto seguido Lenis desplazaba la página 3765 px hasta el `<aside>`,
           que vive fijo fuera de pantalla. Medido: `scrollY` 0 → 3765 de un
           clic en «Carrito».
           El guardia es `defaultPrevented`: los oyentes del propio elemento
           corren antes que este del documento, así que cuando alguien ya
           resolvió el clic, aquí no hay nada que hacer.

       (b) SALTAR AL CONTENIDO. Ese enlace no quiere un viaje suave: quiere
           MOVER EL FOCO a `<main>`, y eso solo pasa si el navegador procesa la
           navegación de verdad. Con `preventDefault` el foco se quedaba en el
           propio enlace y el salto no servía para nada — que es exactamente lo
           que venía a arreglar. Se deja pasar, y de paso llega instantáneo, que
           es lo que debe ser. */
    if (e.defaultPrevented) return;
    const a = e.target.closest('a[href^="#"]');
    if (!a || a.getAttribute('href') === '#') return;
    if (a.classList.contains('salto') || a.hasAttribute('data-sin-suave')) return;
    const destino = document.querySelector(a.getAttribute('href'));
    if (!destino) return;
    e.preventDefault();
    irA(destino);
  });

  /* Con el panel de menú abierto el fondo NO se mueve: `overflow:hidden` en el
     body ya no basta porque quien manda el scroll es Lenis. */
  new MutationObserver(() => {
    document.body.classList.contains('trabado') ? lenis.stop() : lenis.start();
  }).observe(document.body, { attributes:true, attributeFilter:['class'] });
}

/* ══════════════════════════════════════════════════════════════════════════
   EL CLIC QUE SE PIERDE PORQUE LA PÁGINA SIGUE DESLIZANDO
   ══════════════════════════════════════════════════════════════════════════
   🔴 paco, 30-ago: *"no siempre te deja darle click, hay un bug aquí"*. No era
   el enlace ni una capa encima: es el scroll suave.

   El navegador solo emite `click` si `pointerdown` y `pointerup` caen sobre el
   MISMO elemento. Con Lenis la página sigue deslizando por inercia después de
   soltar la rueda, así que si pulsas en ese momento **el botón se va bajo el
   dedo**. Medido en §tienda, 30 ms después de pulsar: se desplazaba **12, 21 y
   25 px**, y en uno de cada tres intentos el punto donde se pulsó ya no era el
   botón sino la tarjeta de detrás. Ahí el clic no se pierde «a veces»: no
   existe, porque el navegador nunca lo genera. Por eso es intermitente y por
   eso parecía un enlace muerto.

   🔴 Y AQUÍ ESTÁ LA PARTE QUE CASI ROMPO. La corrección obvia —«si el pointerup
   no cae en el enlace, navega igual»— se carga un gesto que existe en todos los
   sistemas desde siempre: **pulsar, arrepentirse, arrastrar fuera y soltar para
   CANCELAR**. Con esa regla, cancelar navegaría.

   Lo que distingue un caso del otro no es cuánto se movió el puntero: es QUIÉN
   se movió. Se guarda la posición del puntero DENTRO del enlace (dx, dy) y se
   vuelve a medir al soltar. Si el dedo sigue en el mismo punto del botón, fue
   la PÁGINA la que se movió y el clic hay que rescatarlo; si el dedo cambió de
   sitio dentro del botón, se movió la MANO y hay que respetar lo que decida el
   navegador —incluida la cancelación—.

   Las demás guardas:
   · Solo botón principal: el del medio abre pestaña y el derecho el menú.
   · Con Ctrl/Cmd/Shift/Alt no se toca nada: son «abrir en otra pestaña».
   · Si el enlace NO se movió, no hay nada que rescatar: manda el navegador.  */
(() => {
  let abajo = null;

  addEventListener('pointerdown', e => {
    if (e.button !== 0) return;
    const a = e.target instanceof Element ? e.target.closest('a[href]') : null;
    if (!a) { abajo = null; return; }
    const r = a.getBoundingClientRect();
    abajo = { a, dx: e.clientX - r.left, dy: e.clientY - r.top, top: r.top };
  }, true);

  addEventListener('pointercancel', () => { abajo = null; }, true);

  addEventListener('pointerup', e => {
    const p = abajo; abajo = null;
    if (!p || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    const r = p.a.getBoundingClientRect();

    /* ¿Se movió el enlace? Si no, no hay nada que rescatar. */
    if (Math.abs(r.top - p.top) < 4) return;

    /* ¿Y el dedo se quedó donde estaba DENTRO del enlace? Si se movió, fue la
       mano: puede ser un arrastre o una cancelación, y ninguna es un clic. */
    if (Math.abs((e.clientX - r.left) - p.dx) > 6) return;
    if (Math.abs((e.clientY - r.top)  - p.dy) > 6) return;

    /* El puntero sigue sobre el mismo punto del botón, pero el botón ya no está
       donde el navegador lo vio al bajar el dedo: el clic no va a llegar. */
    const bajo = document.elementFromPoint(e.clientX, e.clientY);
    if (bajo && (bajo === p.a || p.a.contains(bajo))) return;   /* llegará solo */
    p.a.click();
  }, true);
})();
